import React from 'react';

import {
	isEmpty,
	styled
} from 'ps-gui';
import { getFormItemLabel } from '../../data/phrases';


const Wrapper = styled.div`
	width: 100%;
	margin-bottom: 8px;

	display: table;
	background: #FFDA55;
	border-radius: 15px;
	box-shadow: -4px 2px 33px rgba(0, 0, 0, 0.1);
	padding: ${props => props.padding || '8px'};
	margin: ${props => props.margin || '8px auto'};
	max-width: ${props => props.maxWidth};
	color: ${props => props.theme.disabledTextColor};
	text-align: justify;
	max-width: 540px;

	> .header {
		padding: ${props => props.theme.inputPadding};
		font-weight: 500;
	}

	> .comments {
		padding: ${props => props.theme.inputPadding};
		white-space: pre-wrap;
	}

`;

export default class LatestStatus extends React.Component {
	render() {
		const transitions = this.props.transitions;
		if (transitions?.size > 0) {
			const lt = transitions.get(0);
			const comments = lt.get('comments');
			if (isEmpty(comments)) {
				return null;
			}
			return (
				<Wrapper>
					<div className='header'>
						{getFormItemLabel('intergram_comment')}:
					</div>
					<div className='comments'>
						{comments}
					</div>
				</Wrapper>
			);
		}
		return null;
	}
}

